import AWS from 'aws-sdk';

export function getFileExtension(filePath) {
  // return filePath.substr(filePath.lastIndexOf("\\") + 1).split(".")[1];
  var filename = filePath.substr(filePath.lastIndexOf('\\') + 1);
  var re = /(?:\.([^.]+))?$/;
  var ext = re.exec(filename)[1];
  return ext;
  // changes for filename with multiple dots.
}

export function getS3Details() {
  return new AWS.S3({
    accessKeyId: 'AKIAUCFV3ISYTAV7WV3Y',
    secretAccessKey: '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',
    region: 'ap-south-1',
  });
}

// API for the chatbot.
export const API_CHATBOT_BASE_URL = 'http://35.200.230.149:3000';

// API to start the processing of EHR file.
export const API_FILE_PROCESS = 'https://ehr-first-31552869844.asia-south1.run.app';

// API to process selected tests.
export const API_TEST_PROCESS = 'http://34.93.251.60:5000';
